export const positionsByElementType: Record<string, number[]> = {
  "1": [1, 2],
  "2": [3, 4, 5, 6, 7],
  "3": [8, 9, 10, 11, 12],
  "4": [13, 14, 15],
};
